import { AlertProvider } from './../alert/alert';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, Platform } from 'ionic-angular';
import { HttpProvider } from "../../providers/http/http";
import { VeiculoModel } from './../../app/models/VeiculoModel';


@Injectable()
export class AtendimentoProvider {

  veiculo: VeiculoModel = new VeiculoModel();
  atendimento:any = [];
  tipoDispositivo: string;

  constructor(
    public http: HttpClient,
    private alertCtrl: AlertController,
    private httpSrv: HttpProvider,
    private alertSrv: AlertProvider,
    private platform: Platform
    
  ) {


    if (this.platform.is("core")) {
      this.tipoDispositivo = "browser";
    }

    if (this.platform.is("ipad")) {
      this.tipoDispositivo = "ipad";
    }

    if (this.platform.is("android")) {
      this.tipoDispositivo = "celular";
    }

    if (this.platform.is("tablet") && this.platform.is("android")) {
      this.tipoDispositivo = "tablet";
    }

    if (this.platform.is("iphone")) {
      this.tipoDispositivo = "iphone";
    }

  }

  async enviaOrcamento(atendimento){
    this.atendimento = await this.getAtendimento(atendimento.id);
    var url = 'v1/montaEnvioAtendimento';
    var body = {
      "idAtendimento": this.atendimento.id
    };

    if(!this.atendimento.telefoneCliente && !this.atendimento.telefone){
      const prompt = this.alertCtrl.create({
        title: 'Atendimento sem telefone do cliente',
        message: "Insira o número do cliente para que receba os dados do atendimento",
        inputs: [
          {
            name: 'telefone',
            placeholder: 'Número de telefone',
            type: 'text',
          },
        ],
        buttons: [
          {
            text: 'Cancelar',
            handler: data => {

            }
          },
          {
            text: 'Ok',
            handler: data => {
              if(data.telefone == ''){
                return false;
              }
              this.atendimento.telefoneCliente = data.telefone;
              // this.atendimento.telefoneCliente = this.veiculo.telefone;
              this.atualizaAtendimento(this.atendimento).then(x=>{
                try {
                  this.httpSrv.postApi(url, body, 1, 1).then(ResultConn => {
                    if (ResultConn.success) {
                      let urlFormatada = ResultConn.data.url;
                      window.open(urlFormatada, '_blank');
                    }  
                  })
                } catch (error) {
                  console.log('Problema ao tentar montar o endereço.', error);
                }
              });
            }
          }
        ]
      });
      prompt.present();
    }else{
      try {
        this.httpSrv.postApi(url, body, 1, 1).then(ResultConn => {
          if (ResultConn.success) {
            let urlFormatada = ResultConn.data.url;
            window.open(urlFormatada, '_blank');
          }  
        })
      } catch (error) {
        console.log('Problema ao tentar montar o endereço.', error);
      }
    }
  }

  async getMensagemCompartilhamento(atendimento){
    this.atendimento = await this.getAtendimento(atendimento.id);
    var url = 'v1/montaEnvioAtendimento';
    var body = {
      "idAtendimento": this.atendimento.id
    };

    if(!this.atendimento.telefoneCliente && !this.veiculo.telefone){
      const prompt = this.alertCtrl.create({
        title: 'Atendimento sem telefone do cliente',
        message: "Insira o número do cliente para que receba os dados do atendimento",
        inputs: [
          {
            name: 'telefone',
            placeholder: 'Número de telefone',
            type: 'text',
          },
        ],
        buttons: [
          {
            text: 'Cancelar',
            handler: data => {

            }
          },
          {
            text: 'Ok',
            handler: data => {
              if(data.telefone == ''){
                return false;
              }
              this.atendimento.telefoneCliente = data.telefone;
              this.atualizaAtendimento(this.atendimento).then(x=>{
                try {
                  this.httpSrv.postApi(url, body, 1, 1).then(ResultConn => {
                    if (ResultConn.success) {
                      let urlWhatsApp = ResultConn.data.urlWhatsapp;
                      let mensagemHtml = ResultConn.data.mensagemHtml.replaceAll('\\n', '\n');
                      if(this.tipoDispositivo != 'browser'){
                        var options = {
                          message: mensagemHtml, 
                          subject: 'Assunto', 
                          files: ['"https://camptecnologia.com.br/wp-content/uploads/aplicativo-indicar-oleos-e-filtros-1024x948.png"', '"https://camptecnologia.com.br/wp-content/uploads/aplicativo-indicar-oleos-e-filtros-1024x948.png"'], 
                          url: null,
                          chooserTitle: 'Escolha um aplicativo', 
                          appPackageName: null
                        };
                        // this.socialSharing.share(options.message, options.subject, null, null);
                      }else{
                        window.open(urlWhatsApp, '_blank');
                      }
                    }  
                  })
                } catch (error) {
                  console.log('Problema ao tentar montar o endereço.', error);
                }
              });
            }
          }
        ]
      });
      prompt.present();
    }else{
      try {
        this.httpSrv.postApi(url, body, 1, 1).then(ResultConn => {
          if (ResultConn.success) {
            let urlWhatsApp = ResultConn.data.urlWhatsapp;
            let mensagemHtml = ResultConn.data.mensagemHtml.replaceAll('\\n', '\n');
            console.log(mensagemHtml);
            
            if(this.tipoDispositivo != 'browser'){
              var options = {
                message: mensagemHtml, 
                subject: 'Assunto', 
                files: ['"https://camptecnologia.com.br/wp-content/uploads/aplicativo-indicar-oleos-e-filtros-1024x948.png"', '"https://camptecnologia.com.br/wp-content/uploads/aplicativo-indicar-oleos-e-filtros-1024x948.png"'], 
                url: null,
                chooserTitle: 'Escolha um aplicativo', 
                appPackageName: null
              };
              // this.socialSharing.share(options.message, options.subject, null, null);
            }else{
              window.open(urlWhatsApp, '_blank');
            }
          }  
        })
      } catch (error) {
        console.log('Problema ao tentar montar o endereço.', error);
      }
    }
  }

  async atualizaAtendimento(atendimento, loading = 1) {
    var url = 'v1/atualizaAtendimento';
    var body = atendimento;
    try {
      let ResultConn = await this.httpSrv.postApi(url, body, loading, 1);
      if (ResultConn.success) {
        atendimento = ResultConn.data;
      } else {
        this.alertSrv.alert("OPS...", "Aconteceu algo inesperado ao salvar alteração do orçamento.");
        return false;
      }
    } catch (error) {
      console.log('Problema ao tentar alterar orçamento.', error);
    }
  }

  async getAtendimento(idAtendimento){
    let body = {
      "idAtendimento" : idAtendimento
    }
    try {
      let ResultConn = await this.httpSrv.postApi("v1/getAtendimento", body);
      if (ResultConn.success) {
        this.atendimento = ResultConn.data;
        return this.atendimento;
      }
    } catch (error) {
      console.log("Problema ao buscar atendimento", error);
    }

  }

  async atualizaStatusAtendimento(idAtendimento, status) {
    this.atendimento.status = status;
    var url = "alteraOrcamento";
    var body = {
      idOrcamento: idAtendimento,
      estado: status,
    };
    try {
      let ResultConn = await this.httpSrv.postApi(url, body, 1, 1);
      if (ResultConn.success) {

      }
    } catch (error) {
      console.log("Problema ao tentar alterar atendimento.", error);
    }
  }

  async enviaEmailAtendimento(atendimento){
    let resultado;
    this.atendimento = atendimento;

    if(this.atendimento.emailCliente == ''){
      return {success : false, mensagem : "Atendimento sem email do cliente!"};
    }

    var url = 'enviaEmailAtendimento';
    var body = {
      "atendimento": this.atendimento
    };
    try {

      let resultado = await this.httpSrv.postApi(url, body, 1, 1);
      if(resultado.success) {
        return {success : true, mensagem : "Atendimento enviado."};
      }else{
        return {success : false, mensagem : "Ocorreu algum problema ao tentar enviar o atendimento para o email do cliente."};
      }

    } catch (error) {
      return {success : false, mensagem : "Ocorreu algum problema ao tentar enviar o atendimento para o email do cliente."};
    }

  }

}



// WEBPACK FOOTER //
// ./src/providers/atendimento/atendimento.ts